module.exports = __webpack_public_path__ + "static/media/fuel.4bcda326.webp";